"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const styled_components_1 = __importDefault(require("styled-components"));
const mui_1 = require("tss-react/mui");
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const ReportProblemLink_1 = __importDefault(require("components/ReportProblemLink"));
const unplugged_png_1 = __importDefault(require("assets/error-page/unplugged.png"));
const styles = () => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: 800,
        flexGrow: 1,
        margin: '46px auto 0 auto',
        padding: 40,
    },
    buttonRoot: {
        maxHeight: '32px !important',
        marginBottom: 20,
    },
});
const Heading = styled_components_1.default.h1 `
  font-size: 34px;
  color: ${({ theme }) => theme.palette.text.brand};
  font-weight: 200;
  margin: 0;
`;
const Subheading = styled_components_1.default.h2 `
  font-size: 18px;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: 400;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
const useStyles = (0, mui_1.makeStyles)()(styles);
const ErrorPage = () => {
    const { classes } = useStyles();
    return (<Paper_1.default className={classes.root}>
      <Heading>Uh Oh.  Something isn&rsquo;t quite right here.</Heading>
      <Subheading>
        Our mistake! Rest assured, we&rsquo;re working to resolve the problem as soon as possible.<br />
        We apologize for the inconvenience.
      </Subheading>
      <react_router_1.Link to="/" style={{ textDecoration: 'none' }}>
        <Button_1.default variant="contained" color="primary" className={classes.buttonRoot}>
          RETURN TO DASHBOARD
        </Button_1.default>
      </react_router_1.Link>
      <ReportProblemLink_1.default feedbackSubject="report js crash"/>
      <img alt="electrical cord unplugged" src={unplugged_png_1.default} role="presentation" style={{ maxWidth: 509 }}/>
    </Paper_1.default>);
};
exports.default = ErrorPage;
